import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./header";

const API_ENDPOINT = API_URL + "/api";

export function createRoute(data, params) {
  let obj = {
    ...getHeaderOptions(),
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  return axios.post(`${API_ENDPOINT}/UserRoute/CreateNewRoute`, data, {
    headers: obj,
    params: params,
  });
}

export function getUserRoutes(params) {
  let obj = {
    ...getHeaderOptions(),
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  return axios.get(`${API_ENDPOINT}/UserRoute/GetUserRouteHeaderList`, {
    headers: obj,
    params: params,
  });
}

export function deleteRouteFromList(params) {
  let obj = {
    ...getHeaderOptions(),
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  return axios.post(`${API_ENDPOINT}/UserRoute/DeleteRoute`, null ,{headers: obj,params: params});
}

export function updateRouteHeader(params) {
  let obj = {
    ...getHeaderOptions(),
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  const data = {
    routeID: params.routeID,
    routeName: params.routeName,
    routeStartingDate: params.routeStartingDate
  }
  const userEmail = {
    userName: params.userName
  }
  return axios.post(`${API_ENDPOINT}/UserRoute/UpdateRouteHeader`, data, {
    headers: obj, params: userEmail,
  });
}
export function updateRouteDetail(data, params) {
  let obj = {
    ...getHeaderOptions(),
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  return axios.post(`${API_ENDPOINT}/UserRoute/UpdateRouteDetail`, data, {
    headers: obj, params: params,
  });
}

export function pointList() {
  return axios.get(`${API_ENDPOINT}/mkmphone`, { headers: getHeaderOptions() });
}

export function routeDetail(params) {
  let obj = {
    ...getHeaderOptions(),
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  return axios.get(`${API_ENDPOINT}/UserRoute/GetUserRouteDeatilsList`, {headers: obj, params: params});
}